import 'bootstrap'
import 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import swal from 'sweetalert2'
import Request from './request'
import DatatableFactory from 'vuejs-datatable/dist/vuejs-datatable.esm.js'

//Required Stylesheets
import '@/assets/icons/icofont/css/icofont.css'
import '@/assets/icons/themify-icons/themify-icons.css'
import '@/assets/css/jquery.mCustomScrollbar.css'
import '@/assets/vendors/datatables.net-bs4/css/responsive.bootstrap4.min.css'
import '@/assets/css/style.css'
import '@/assets/css/pcoded-horizontal.min.css'
import '@/assets/css/component.css'
import '@/assets/css/dashboard.css'


//Required JS
// import '@/assets/js/jquery-ui.min.js'
import '@/assets/js/SmoothScroll.js'
import '@/assets/js/pcoded.min.js'
import '@/assets/js/demo-12.js'
import '@/assets/js/script.js'
import '@/assets/js/menu-hori-fixed.js'

Vue.config.productionTip = false
Vue.use(DatatableFactory)

//var socket = io('https://pizzajungle.website:3300', {secure: true, rejectUnauthorized: false});
//var socket = io('localhost:3300');

Vue.prototype.$socket = Request
Vue.prototype.$swal = swal
//Vue.prototype.$store = store

router.beforeEach((to, from, next) => {
	if(to.meta.requiresAuth){
		if (store.getters.isLoggedIn) {
			next()
			return
		}
		next('/') 
	} else {
		next() 
	}
})



var capitalizeWords = (s) => {
	return s
	    .toLowerCase()
	    .split(' ')
	    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
	    .join(' ')
}



//Add to Vue prototypes

Vue.prototype.$capitalizeWords = capitalizeWords

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
